var _defs, _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g2, _path19, _path20, _path21, _g3, _path22, _path23, _path24, _path25, _g4, _path26, _path27, _path28, _path29, _path30, _path31, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelfie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 440,
    height: 148,
    viewBox: "0 0 440 148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_10",
    "data-name": "\\u6955\\u5186\\u5F62 10",
    cx: 69,
    cy: 69,
    r: 69,
    transform: "translate(-0.331)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1616",
    "data-name": "\\u30D1\\u30B9 1616",
    d: "M0,0H52.43V76.853H0Z",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_343",
    "data-name": "\\u9577\\u65B9\\u5F62 343",
    width: 136.096,
    height: 148,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_342",
    "data-name": "\\u9577\\u65B9\\u5F62 342",
    width: 136.096,
    height: 419.868,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_338",
    "data-name": "\\u9577\\u65B9\\u5F62 338",
    width: 37.653,
    height: 88.631,
    fill: "#3e3d3b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_339",
    "data-name": "\\u9577\\u65B9\\u5F62 339",
    width: 45.692,
    height: 58.56,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_341",
    "data-name": "\\u9577\\u65B9\\u5F62 341",
    width: 54.936,
    height: 67.464,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "img",
    transform: "translate(-180 -783)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_23",
    "data-name": "\\u9577\\u65B9\\u5F62 23",
    width: 440,
    height: 148,
    transform: "translate(180 783)",
    fill: "#f5f5f5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_170",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 170",
    transform: "translate(268.712 796.724)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30DE\\u30B9\\u30AF\\u30B0\\u30EB\\u30FC\\u30D7_5",
    "data-name": "\\u30DE\\u30B9\\u30AF\\u30B0\\u30EB\\u30FC\\u30D7 5",
    transform: "translate(-18.381 -10.724)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_11",
    "data-name": "\\u6955\\u5186\\u5F62 11",
    cx: 69,
    cy: 69,
    r: 69,
    transform: "translate(-0.331)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1594",
    "data-name": "\\u30D1\\u30B9 1594",
    d: "M21.281,5.417V95.871a5.417,5.417,0,0,0,5.417,5.417H70.756a5.417,5.417,0,0,0,5.417-5.417V5.417A5.417,5.417,0,0,0,70.756,0H26.7a5.417,5.417,0,0,0-5.417,5.417",
    transform: "translate(18.547 15.432)",
    fill: "#8180c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_344",
    "data-name": "\\u9577\\u65B9\\u5F62 344",
    width: 49.475,
    height: 78.897,
    transform: "translate(42.535 26.628)",
    fill: "#c7e3f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30DE\\u30B9\\u30AF\\u30B0\\u30EB\\u30FC\\u30D7_4",
    "data-name": "\\u30DE\\u30B9\\u30AF\\u30B0\\u30EB\\u30FC\\u30D7 4",
    transform: "translate(42.29 28.956)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1602",
    "data-name": "\\u30D1\\u30B9 1602",
    d: "M40.211,38.232a4.11,4.11,0,0,1,.527-.786.729.729,0,0,1,.869-.069c1.68,2.73,7.694,7.379,10.661,8.682,4.5-2.205,10.291-8.205,11.475-9.628.147-.245.692-.231.93.025a18.191,18.191,0,0,1,1.049,1.507c.963.69,2.83,1.469,3,2.421,4.972,2.923,10.365,4.172,16.809,6.142A35.657,35.657,0,0,1,89,47.761a2.222,2.222,0,0,1,.926.957c.3-.269.894-.047,1.227.208,1.5,1.151,2.665,6.416,3.119,8.28,1.2,4.918,2.378,8.584,3.24,12.716,1.8,8.636,2.88,16.917,3.959,25.557.585,4.676,1.008,9.683,1.417,14.275a46.54,46.54,0,0,1-.678,12,141.509,141.509,0,0,1-8.146,30.234c-.031,2.34-.093,5.486-.007,7.325a35.254,35.254,0,0,1,.056,3.994,1.008,1.008,0,0,1-.719,1.024,11.759,11.759,0,0,1-1.812.368c-.956.154-1.906.293-3.079.475a22.553,22.553,0,0,1-1.013,3.729,8.333,8.333,0,0,1-1.114,1.933c.482,1.408.563,6.546.582,8.148.015,1.5.089,3.6.089,5.1,0,3.058.179,5.641.179,8.7,0,6.379-1.259,12.25-1.259,18.719,0,13.493-.3,32.88-3.1,45.851a38.854,38.854,0,0,0-1.08,12.5,23.46,23.46,0,0,1-.065,7.119,4.8,4.8,0,0,1-2.859,3.641c2.36,2.256,3.747,6.375,4.218,8.643.481,2.308,1.192,5.572-.128,7.771-1.295,2.167-4.7,3.932-7.1,4.285a10.373,10.373,0,0,1-8.034-1.663c-2.606-1.93-2.737-7-2.733-10.217,0-3.022-1.008-7.135,1.236-9.258a7.828,7.828,0,0,1-2.981-3.788,22.2,22.2,0,0,1-.689-6.212,97.389,97.389,0,0,0-.179-12.958c-.063-.7-.194-4.632-.181-5.758.138-12.967,1.222-29.089.181-41.947-.568-7-.791-13.623-2.074-20.5-.644-3.476-1.106-6.651-1.883-10.08-.382-1.686-.711-3.431-1.259-5.129-.393-1.211-1.261-4.006-1.892-5.487-.719,1.889-1.533,4.244-1.89,5.67a31.976,31.976,0,0,0-.945,5.714c-.228,3.4-.63,6.3-.943,9.669-.355,3.826-.011,7.666,0,11.525.008,3.457-.36,6.91-.36,10.444,0,7.142-.366,14.12-.359,21.229.007,6.987-1.557,13.9-2.882,20.521-1.483,7.417-.389,11.329-1.95,18.528a36.89,36.89,0,0,0-.841,6.718,29.059,29.059,0,0,0,.387,5.445,16.986,16.986,0,0,1-.12,5.289c-.192,1.489.283,3.839-.109,4.866-.158.415-.928.44-1.686.537,1.918,2.116,1.714,6.412.916,9.054a2.256,2.256,0,0,1,.428,1.308c.137,2.493-.013,3.322-2.591,4.523a21.568,21.568,0,0,1-5.372,1.973c-.708-.956-1.721-1.425-2.407-1a9.584,9.584,0,0,0-2.184,2.213c-3.111,2.733-5.873,3.436-10.01,3.762s-10.719-.426-11.061-2.663a1.758,1.758,0,0,1,.34-1.457c.1-2.909,1.7-5.026,3.863-7.079,2.177-2.07,5.276-4.069,7.478-6.232,2.08-2.04,4.057-3.47,4.863-4.862a10.517,10.517,0,0,1-2.69-1.132c-.253-2.67-.483-7.171-1-10.036-.571-3.16-.684-6.647-.977-10.166-.577-6.923-.025-12.365.456-19.293.6-8.639,1.081-16.319,1.914-24.235a100.628,100.628,0,0,0,.217-10.085c0-3.907-.312-7.71-.54-11.689-.413-7.24-1.137-14.518-1.8-21.768-.3-3.232-.947-6.285-1.439-9.511-.564-3.688-.165-7.468-.9-11.016a12.222,12.222,0,0,1-3.572-.931c-1.647-10.246,1.177-20.58,2.673-30.5.91-6.036,1.524-12.286,2.794-18.054a53.134,53.134,0,0,0,.978-9.285c.083-1.552.191-3.3.293-4.79a33.315,33.315,0,0,1,.195-3.91c-.977,3.128-1.3,4.505-2.247,7.722-1.139,3.886-1.5,7.631-2.333,11.557-.678,3.2-1.976,6.414-2.158,9.682-.188,3.3-1.71,6.077-1.7,9.355a64.86,64.86,0,0,1-.311,9.536,77.382,77.382,0,0,0-.78,9.428c0,.217-.317.123-.514.084-4.505-.761-10.563-.392-13.81,1.5-.086.05-.274-.133-.286-.285a61.776,61.776,0,0,1-.283-10,106.277,106.277,0,0,0,.726-10.8c0-13.489,4.372-26.676,6.344-39.771A61.523,61.523,0,0,1,9.3,86.956c.875-2.914,1.235-5.813,2.121-8.636,1.966-6.273,2.289-13.57,2.924-20.167.256-2.67.184-5.6,2.3-7.046a.9.9,0,0,1,1.152-.091,1.889,1.889,0,0,1,.881-1.221,35.775,35.775,0,0,1,5.246-2.609c2.651-1.065,4.557-2.045,7.033-3.307,1.331-.676,2.676-1.392,4.362-2.236.5-.249,1.411-.714,2.144-1.044.036-.807,2.045-1.8,2.748-2.367",
    transform: "translate(-26.516 9.846)",
    fill: "#3e3d3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1603",
    "data-name": "\\u30D1\\u30B9 1603",
    d: "M45.421.007a19.667,19.667,0,0,1,7.522,1.256,13.676,13.676,0,0,1,5.081,3.823c3.194,3.874,3.284,8.631,2.819,13.719,2.452-.716,1.628,3.607.73,7.3-.631,2.565-1.555,4.374-2.883,4.542a23.3,23.3,0,0,1-2.156,5.805,16.8,16.8,0,0,0,.9,3.6A15.515,15.515,0,0,0,58.557,42.7c-1.184,1.423-6.973,7.423-11.473,9.628-2.969-1.3-8.983-5.953-10.661-8.682.083-2.487.367-5.876.314-7.154a17.221,17.221,0,0,1-2.475-5.173c-1.711.135-2.231-2.487-3.194-5.174-1.089-3.038-1.906-7.145.312-6.592-.88-3.739.191-9.748,1.98-13.025a15.412,15.412,0,0,1,4.866-4.822c1.413-.9,4.793-1.63,7.2-1.7",
    transform: "translate(-21.33 3.574)",
    fill: "#f6cbb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1604",
    "data-name": "\\u30D1\\u30B9 1604",
    d: "M.946,140.036l-.169-1.159c3.3-1.776,9.181-2.113,13.586-1.37l-.121,2.067s-.025.367-.346.314c-.152-.026-.325-.048-.51-.068-.883-.1-2.046-.152-2.748-.185C9.6,139.585,8.6,139.6,7.569,139.6a23.488,23.488,0,0,0-5.66.623c-.162.041-.323.084-.481.13-.359.124-.482-.318-.482-.318",
    transform: "translate(-26.381 27.297)",
    fill: "#bdbebf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1605",
    "data-name": "\\u30D1\\u30B9 1605",
    d: "M38.654,31.612c1.622,1.146,3.711,2.721,7.093,2.557a9.2,9.2,0,0,0,6.6-2.97c1.238-1.32,1.9-.659.907.826a37.261,37.261,0,0,1-4.371,4.948,5.493,5.493,0,0,1-6.021-.082c-1.649-1.4-4.288-3.382-4.949-4.206s-.659-2.062.743-1.072",
    transform: "translate(-20.031 8.849)",
    fill: "#c59d8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1606",
    "data-name": "\\u30D1\\u30B9 1606",
    d: "M31.218,19.556A7.8,7.8,0,0,1,31.8,21.8a4.932,4.932,0,0,0,.929.244,28.481,28.481,0,0,1-.049-5.45c.087-1.236.309-1.778.933-2.244a1.816,1.816,0,0,0,.8-1.494c.049-.88.217-2.323.2-2.982-.025-.782.922-1.24,1.872-1.541A42.6,42.6,0,0,1,46.8,7.2,37.821,37.821,0,0,1,55.073,8c.66.248,2.393.793,2.475,1.7s.087,2.947.087,3.524a1.553,1.553,0,0,0,.751,1.39,3.1,3.1,0,0,1,.96,2.251c0,.88.156,3.593.074,4.252l.806-.17a4.976,4.976,0,0,1,.457-2.143c.464-5.09.374-9.845-2.82-13.72a13.675,13.675,0,0,0-5.08-3.823A19.664,19.664,0,0,0,45.259.008c-2.4.069-5.78.8-7.194,1.7A15.412,15.412,0,0,0,33.2,6.531c-1.789,3.277-2.861,9.284-1.981,13.025",
    transform: "translate(-21.169 3.574)",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1607",
    "data-name": "\\u30D1\\u30B9 1607",
    d: "M78.189,144.035c-.11.312-.415.313-.672.277a3.845,3.845,0,0,1,.251-.7,9.4,9.4,0,0,0-4.674-5.572,12.9,12.9,0,0,0-3.721-1.466c-.659-.147-1.335-.058-1.386.148-.023.089-.043.176-.061.255a3.4,3.4,0,0,1-1.394-2.125,2.779,2.779,0,0,1,.586-1.723,27.56,27.56,0,0,1,6.17,1.811,11.709,11.709,0,0,1,4.231,3.331,6.674,6.674,0,0,1,.67,5.763",
    transform: "translate(-15.007 26.604)",
    fill: "#bdbebf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1608",
    "data-name": "\\u30D1\\u30B9 1608",
    d: "M35.678,37.376a.731.731,0,0,0-.87.069,4.248,4.248,0,0,0-.525.786c0,12.733,1.656,25.7,5.614,37.4.527,1.557,1.049,3.335,1.585,4.891,1.813,5.142,3.524,7.488,5.772,10.958,2.053-3.592,2.932-5.376,4.89-11.543.321-.856.893-2.746,1.659-5.8A178.065,178.065,0,0,0,57.682,56.4c.857-5.9,2.111-12.733,2.111-18.439-.176-.291-.861-1.3-1.049-1.506-.238-.257-.785-.27-.931-.026-1.185,1.423-6.973,7.423-11.474,9.628-2.968-1.3-8.982-5.953-10.661-8.682",
    transform: "translate(-20.585 9.846)",
    fill: "#bdbebf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1609",
    "data-name": "\\u30D1\\u30B9 1609",
    d: "M13.315,139.455c-.883-.1-2.047-.153-2.749-.184-1.038-.049-2.035-.033-3.067-.035a23.559,23.559,0,0,0-5.661.624c.1,1.172-.772,5.348-.643,6.342.216,1.641.065,3.222.274,4.814.29,2.2,3.018,5.615,4.951,6.562,1.577.775,3.6,2.557,5.488,2.257,1.063-.174,2-1.155,1.417-2.211a2.969,2.969,0,0,0-2.757-1.2c.248-1.03-1.452-2.021-2.158-2.323.956-.791.639-4.484.07-5.468a4.453,4.453,0,0,0,1.606-2.425c.236.76.314,1.534.543,2.315a4.471,4.471,0,0,0,.806,1.8c.093,1.2-.518,3.147.813,3.8s1.947-.8,2.373-1.874a6.31,6.31,0,0,0,.623-3.844,23.808,23.808,0,0,1-.78-3.883c-.122-2.272-1.125-3.25-1.15-5.057",
    transform: "translate(-26.311 27.661)",
    fill: "#f6cbb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1610",
    "data-name": "\\u30D1\\u30B9 1610",
    d: "M68.771,136.481a7.289,7.289,0,0,1-2.034,4,14.349,14.349,0,0,0-2.028,2.4,5.839,5.839,0,0,0-.367,1.1c-.341.83-.967,1.783-1.308,2.5a3.361,3.361,0,0,0-.366,1.191c-.66,1.026-.884,1.967-.33,2.224,1.371.632,2.811-.269,3.738-1.32a6.014,6.014,0,0,0-.839,1.561,7.556,7.556,0,0,0-1.727,2.691c-1.466,1.051-2.238,2.24-1.71,3.006.285.415.488.587,1.4.653.019.544.849,1.008,1.64.816a2.714,2.714,0,0,0,2.02.314c.4.367,1.171.266,1.687.219a12.982,12.982,0,0,0,2.737-.659,5.532,5.532,0,0,0,1.564-.758,30.138,30.138,0,0,0,2.869-2.832,8.37,8.37,0,0,0,1.114-1.934,22.524,22.524,0,0,0,1.013-3.729,24.678,24.678,0,0,1,.52-4.1,3.874,3.874,0,0,1,.251-.7,9.4,9.4,0,0,0-4.674-5.572,12.935,12.935,0,0,0-3.721-1.466c-.659-.147-1.335-.057-1.386.148-.023.089-.043.177-.061.255",
    transform: "translate(-15.853 27.102)",
    fill: "#f6cbb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1611",
    "data-name": "\\u30D1\\u30B9 1611",
    d: "M56.762,244.193a11.645,11.645,0,0,0,6.507,1.961,11.765,11.765,0,0,0,6.03-1.521c2.36,2.256,3.747,6.376,4.218,8.643.481,2.309,1.192,5.572-.128,7.771-1.295,2.167-4.7,3.932-7.1,4.285a10.376,10.376,0,0,1-8.034-1.662c-2.606-1.931-2.737-7-2.733-10.218,0-3.022-1.008-7.134,1.236-9.258",
    transform: "translate(-16.949 45.817)",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1612",
    "data-name": "\\u30D1\\u30B9 1612",
    d: "M26.262,255.985c3.494,1.2,8.919,1.857,15.738.463,1.918,2.116,1.714,6.412.916,9.054a2.273,2.273,0,0,1,.428,1.308c.137,2.493-.013,3.322-2.591,4.523a21.589,21.589,0,0,1-5.372,1.973c-.71-.956-1.721-1.425-2.407-1a9.532,9.532,0,0,0-2.184,2.213c-3.112,2.733-5.873,3.436-10.01,3.762s-10.72-.426-11.061-2.663a1.758,1.758,0,0,1,.34-1.457c.1-2.909,1.7-5.026,3.863-7.079,2.177-2.07,5.276-4.069,7.478-6.232,2.079-2.04,4.057-3.47,4.863-4.862",
    transform: "translate(-24.839 47.857)",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1613",
    "data-name": "\\u30D1\\u30B9 1613",
    d: "M40.419,78.933c1.812,5.142,3.522,7.488,5.771,10.958,2.053-3.592,2.932-5.376,4.891-11.543-.043-1.668-.179-3.464-.449-6.168a106.147,106.147,0,0,0-1.607-11.321c-.469-2.4-1.466-4.887-1.447-7.726a19.075,19.075,0,0,0,2.929-3.822c-1.386-1.04-4.014-2.864-5.274-3.852-1.306,1.214-3.442,3.079-4.76,4.464a29.485,29.485,0,0,0,3.016,3.165c.16,2.884-.947,6.477-1.16,7.967-.924,6.484-1.22,9.568-1.413,11.665-.318,3.377-.362,5.2-.5,6.212",
    transform: "translate(-19.524 11.438)",
    fill: "#d72029"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1614",
    "data-name": "\\u30D1\\u30B9 1614",
    d: "M37.382,51.611a15.3,15.3,0,0,0,4.547-1.255A13.906,13.906,0,0,1,41,49.265a18.515,18.515,0,0,1-3.616,2.346",
    transform: "translate(-20.049 12.097)",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1615",
    "data-name": "\\u30D1\\u30B9 1615",
    d: "M53.156,50.992a37.118,37.118,0,0,1-4.008-2.249c-.27.473-.571.926-.881,1.365a26.418,26.418,0,0,0,4.889.883",
    transform: "translate(-18.166 12.006)",
    fill: "#676767"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1595",
    "data-name": "\\u30D1\\u30B9 1595",
    d: "M48.617,2.771a1.264,1.264,0,1,1,0,2.528H34.9a1.264,1.264,0,1,1,0-2.528Z",
    transform: "translate(25.517 16.995)",
    fill: "#5b5b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1596",
    "data-name": "\\u30D1\\u30B9 1596",
    d: "M46.8,64.242C38.959,73.67,32.512,75.285,32.512,71.3V34.044l-4.4,1.969a55.45,55.45,0,0,0-9.689,5.356c-4.51,3.382-10.9,16.3-13.353,27.677-1.757,8.169-.44,26.511-3.858,39.545-.228.87-.033,1.707-.307,2.528,0,9.924,28.224,8.167,28.224-.366v-6.532c0-5.683,7.205-3.581,13.159-11.954,4.1-5.774,7.294-9.067,11.17-17.442C57.473,66.149,62.1,60.964,59,58.339c-4.985-4.219-7.868.685-12.206,5.9",
    transform: "translate(7.05 34.642)",
    fill: "#f6cbb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1597",
    "data-name": "\\u30D1\\u30B9 1597",
    d: "M44.943,61.58C40.3,69.672,36.587,72.8,31.761,78.324c-7,8.02-15.125,5.7-15.286,11.283-.067,2.365-.1,10.391-.138,15.582,2.461-1.165,4.086-2.784,4.086-4.813V93.843c0-5.683,7.205-3.581,13.159-11.954,4.1-5.774,7.294-9.067,11.17-17.442,2.4-5.19,5.01-9.123,6.065-12.014-1.541,2.453-3.765,5.467-5.874,9.146",
    transform: "translate(15.757 45.019)",
    fill: "#eab68f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1598",
    "data-name": "\\u30D1\\u30B9 1598",
    d: "M1.774,81.579c1.478,5.308,24.917,6.121,27.924.186a89.81,89.81,0,0,1,.019,9.171C29.014,97.969.064,96.432,0,90.58a44.288,44.288,0,0,1,1.774-9",
    transform: "translate(6.538 61.465)",
    fill: "#4a4845"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1599",
    "data-name": "\\u30D1\\u30B9 1599",
    d: "M20.512,81.7c-.623,1.228-2.173,2.146-4.233,2.794v9.986c2.434-.785,4.089-1.971,4.252-3.609a89.81,89.81,0,0,0-.019-9.171",
    transform: "translate(15.724 61.533)",
    fill: "#3e3d3b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_171",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 171",
    transform: "translate(411 783)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_146",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 146",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_145",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 145",
    transform: "translate(0 3.089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_144",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 144",
    clipPath: "url(#clip-path-4)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1559",
    "data-name": "\\u30D1\\u30B9 1559",
    d: "M115.5,464.736c-.627.805-2.823,3.324-3.192,3.8-2.2,2.826-25.954,25.344-15,31.9,8.79,5.262,24.4-3.372,27.616-10.2s2.664-11.457,6.746-15.536c2.414-2.409,5.33-5.623,6.233-9.642-.633-5.78-5.858-5.4-10.175-6.537-4.16-1.1-8.751,1.76-12.227,6.216",
    transform: "translate(-17.618 -85.495)",
    fill: "#2e373a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1560",
    "data-name": "\\u30D1\\u30B9 1560",
    d: "M138.534,466.571a3.5,3.5,0,0,1-.649-.265c.01.089.031.159.039.247-.9,4.02-3.819,7.232-6.233,9.642-4.083,4.079-3.534,8.706-6.746,15.536s-18.826,15.46-27.616,10.2a5.571,5.571,0,0,1-2.562-3.056c-.057.175-.121.341-.172.526-.276,2.661.419,4.864,2.733,6.055,9.1,4.709,24.4-3.37,27.616-10.2,3.13-6.651,2.7-11.209,6.452-15.216l.1,1.3a35.9,35.9,0,0,0,7.554-9.144Z",
    transform: "translate(-17.637 -86.991)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1561",
    "data-name": "\\u30D1\\u30B9 1561",
    d: "M27.569,244.472c-.4,0-.4,0-.4-1a39.558,39.558,0,0,1,2.457-8.416c1.3-3.255,1.049-7.262.751-10.069s5.109-10.269,8.564-15.579l-15.434-.958c-1.463,3.537-2.663,6.456-3.2,7.872a40.6,40.6,0,0,1-6.411,10.97c-2.553,3.406-6.06,8.116-6.262,9.919s.952,11.668,1.7,13.371,10.917,3,12.671,2.756.8-1.8.8-1.8a7.36,7.36,0,0,0,1.1-2.708,6.763,6.763,0,0,0,3.556.049c1.5-.551,4.559-1.951,4.31-3.755s-3.807-.652-4.21-.652",
    transform: "translate(-1.42 -38.888)",
    fill: "#f2a983"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1562",
    "data-name": "\\u30D1\\u30B9 1562",
    d: "M21.032,257.488a6.034,6.034,0,0,1-2.252-4.356c-.052-2.156.35-7.363,0-8.514a5.771,5.771,0,0,0-3.257-3.155c-1.451-.5-2.657-1.2-2.053.7s1.554,3.91.7,4.96-1.47.053-.859,2.605a5.217,5.217,0,0,1-.745,4.257s6.4,1.926,7.424,5.291a16.163,16.163,0,0,0,2.943.121c1.408-.2,1.074-1.237.885-1.646-.347.062-2.068.322-2.787-.263",
    transform: "translate(-2.344 -44.943)",
    fill: "#d88f69"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1563",
    "data-name": "\\u30D1\\u30B9 1563",
    d: "M20.685,220.928,19.1,224.094s10.724,2.668,14.4,9.145l2.489-5.545s-5.224-4.39-15.3-6.765",
    transform: "translate(-3.564 -41.215)",
    fill: "#e2e9ed"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1564",
    "data-name": "\\u30D1\\u30B9 1564",
    d: "M59.947,77.121S58.689,73.914,57.738,74c-2.806.258-12.749,9.276-13.957,25.3s-.606,40.684-.606,40.684L19.591,194.693s11.83,1.964,15.756,10.113l13.735-17.81Z",
    transform: "translate(-3.655 -13.805)",
    fill: "#3e3d3b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1565",
    "data-name": "\\u30D1\\u30B9 1565",
    d: "M73.084,426.787l-26.693-1.192h-.6s-2.383,6.2-7.983,8.461-20.258,8.223-24.429,13.823c-3.42,4.594,4.053,10.964,19.663,7.149,11.062-2.7,12.273-8.34,25.262-8.579,8.9-.164,16.087-3.337,17.636-5.005Z",
    transform: "translate(-2.344 -79.396)",
    fill: "#2e373a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1566",
    "data-name": "\\u30D1\\u30B9 1566",
    d: "M58.308,450.083c-12.99.238-14.2,5.876-25.262,8.579-12.112,2.96-19.32-.214-20.348-3.928-1.22,4.36,6.237,9.234,20.348,5.787,10.558-2.579,12.149-7.829,23.564-8.51l.268,1.528s14.3,0,19.066-4.051v-4.41c-1.549,1.668-8.74,4.84-17.636,5",
    transform: "translate(-2.345 -83.031)",
    fill: "#000508"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1567",
    "data-name": "\\u30D1\\u30B9 1567",
    d: "M52.991,217.892s-8.195,21.4-8.195,40a440.364,440.364,0,0,0,3.094,48c1.127,9.395-1.664,79.084-4.289,89.419,0,0,22.373,10.82,36.466-1.77,0,0,2.155-25.458,2.554-35.413.4-9.915,1.66-23.809.765-34.589-.8-9.672.723-18.583,2.937-36.2,2.06-16.407,1.758-55.368,1.758-55.368s-22.152-4.236-28.166-9.215-6.923-4.856-6.923-4.856",
    transform: "translate(-8.134 -40.649)",
    fill: "#091929"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1568",
    "data-name": "\\u30D1\\u30B9 1568",
    d: "M74.691,220.082s-1.027,15.241,2.737,24.439a77.257,77.257,0,0,1,4.766,16.345c1.126,10.639,2.026,13.941,3.584,24.124,3.194,20.856,9.657,44.91,12.663,55.807s5.542,78.6,5.166,87.619c0,0,13.864,6.159,24.072.648,7.657-4.135,8.748-13.039,8.748-13.039s-.664-30.137.653-38.59-2.005-27.009-3.694-31.143-4.392-20.9-2.325-34.436.534-73.415-7.572-81.523H96.865Z",
    transform: "translate(-13.91 -41.057)",
    fill: "#162a3d"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1569",
    "data-name": "\\u30D1\\u30B9 1569",
    d: "M112.26,53.422s-1.576,11.493,2.666,16.78c0,0-17.213,22.859-30.548,19.465s-3.513-17.949-3.513-17.949Z",
    transform: "translate(-14.436 -9.966)",
    fill: "#f4c1a3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1570",
    "data-name": "\\u30D1\\u30B9 1570",
    d: "M107.407,78.656l5.135-1.052a223.634,223.634,0,0,1,25.986,22.367s-10.272,46.785-14.06,52.406-8.025,18.323-8.582,22.445,2.9,20.834,3.343,22.952,2.226,6.351-3.343,7.91-27.663,6.487-44.991,3.5c-14.478-2.494-22.975-11.3-24.09-13.864s3.12-10.7,3.9-14.486.555-19.721,1.447-27.969.779-24.846.779-24.846-2.562-5.458-.668-17.494S58.841,81,64.524,74.764l13.147-.445S72.912,87.468,76.116,89.25,88.926,94.513,92.1,91.658s15.307-13,15.307-13",
    transform: "translate(-8.697 -13.865)",
    fill: "#bdbebf"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1571",
    "data-name": "\\u30D1\\u30B9 1571",
    d: "M86.344,104.881,82.276,94.5l-6.853,7.956,1.633,7.358s-13.315,38.868-14.021,81.245l6.472,11.81,7.124-7.155s1.915-45.649,3.06-55.289,1.8-29.969,1.8-29.969Z",
    transform: "translate(-11.759 -17.629)",
    fill: "#d71f29"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1572",
    "data-name": "\\u30D1\\u30B9 1572",
    d: "M81.008,74.821s-.724,5.2,3.208,6.5c3.262,1.083,14.621-1.879,25.652-11.3l6.357,9.011-25.6,15.83-6.41-9.972-6.937,6.331s-3.475-10.948,3.729-16.4",
    transform: "translate(-14.062 -4.41)",
    fill: "#676767"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1593",
    "data-name": "\\u30D1\\u30B9 1593",
    d: "M81.508,77.855s-.786,8.487,3.484,10.618c3.542,1.768,15.878-3.067,27.856-18.45l5.086,6.78s-14.8,23.239-28.711,27.826L84.713,90.856,75.778,101.64s-2.092-14.882,5.731-23.785",
    transform: "translate(-14.089 -13.063)",
    fill: "#bdbebf"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1573",
    "data-name": "\\u30D1\\u30B9 1573",
    d: "M132.122,207.414c-.446-2.118-3.9-18.83-3.343-22.951s4.793-16.828,8.582-22.446c2.373-3.524,6.5-22.418,9.251-36.034l-15.765,13.511c.563,1.2-3.627,23.371-6.109,30.36s-3.124,14.455-2.564,24.092c.419,7.183-7.93,16.676-6.218,24.074a127.164,127.164,0,0,0,12.823-2.695c5.569-1.559,3.788-5.793,3.343-7.91",
    transform: "translate(-21.589 -23.502)",
    fill: "#203447"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1574",
    "data-name": "\\u30D1\\u30B9 1574",
    d: "M117.01,74.319s-5.861,10.782-10.216,20.47c-3.478,7.737-14.24,29.795-20.2,66.34-1.5,9.212-1.4,22.406-2.324,32.942-1.4,16.058.565,26.946,1.643,35.855,1.2,9.917,11.321,19.048,23.853,17.523,18.013-2.194,29.336-10.711,29.336-10.711s-9.527-44.586-7.729-62.216,15.748-75.61,15.748-75.61L124.084,78.6Z",
    transform: "translate(-15.63 -13.865)",
    fill: "#3e3d3b"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1575",
    "data-name": "\\u30D1\\u30B9 1575",
    d: "M41.686,232.984c-2.559-1.812-1.973-1.9-3.521-5.2,0,0-2.766-5.706,2.733-31.755s8.889-55.912,7.246-67.806S50.272,83.85,61.073,73.5l14.556-2.205s-14.791,28.358-16.417,63.98c-.251,5.461-.015,9.615-.71,16.183-2.527,23.906-7.872,54.885-7.872,72.163,0,7.388-5.716,11.652-8.944,9.368",
    transform: "translate(-6.99 -13.3)",
    fill: "#3e3d3b"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_134",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 134",
    transform: "translate(70.964 60.213)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_133",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 133"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_132",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 132",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1576",
    "data-name": "\\u30D1\\u30B9 1576",
    d: "M124.892,79.491l-7.237-5.47s-5.861,12.6-10.217,22.292a232.127,232.127,0,0,0-20.2,66.338l29.526-47.064-6.354-8.636,7.176.707Z",
    transform: "translate(-87.238 -74.022)",
    fill: "#4a4845"
  }))))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1577",
    "data-name": "\\u30D1\\u30B9 1577",
    d: "M73.652,71.291c-4.022,7.172-12.92,24.695-12.92,24.695l3.279,4.637-5.479,2.319s-1.285,35.487,3.872,48.512c.261-6.107.5-11.609.71-16.183,1.626-35.621,19.261-63.98,19.261-63.98Z",
    transform: "translate(-10.893 -13.3)",
    fill: "#444240"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1578",
    "data-name": "\\u30D1\\u30B9 1578",
    d: "M106.686,7.988c-7.262-4.253-18.26-3.053-25.7,2.689s-9.11,12.212-9.617,15.111S70.152,31.2,69.6,33.413s1.871,4.794,1.871,4.794c-2.248,3.216.1,10.376.722,12.111A3.985,3.985,0,0,0,71.884,52a1.921,1.921,0,0,0,1.489,1.725A39.022,39.022,0,0,1,74.759,60c.109,1.754.24,7.609,7.105,7.3s16.5-4.985,22.416-10.345,11.809-15.82,13.069-26-3.4-18.719-10.663-22.971",
    transform: "translate(-12.969 -1.016)",
    fill: "#f6cbb0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1579",
    "data-name": "\\u30D1\\u30B9 1579",
    d: "M72.314,57.347h0c.816-2.375,2.939-6.11,3.442-8.492.646-3.081-5.594-5.735-5.594-5.735a9.6,9.6,0,0,0,1.432,2.114c-2.248,3.216.1,10.376.722,12.111",
    transform: "translate(-13.089 -8.044)",
    fill: "#f4c1a3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_137",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 137",
    transform: "translate(58.895 4.428)",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_136",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_135",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 135",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1580",
    "data-name": "\\u30D1\\u30B9 1580",
    d: "M107.223,7.988c-7.262-4.253-18.26-3.053-25.7,2.689A24.626,24.626,0,0,0,72.4,23.6c1.175,2.3,2.73,4.048,4.767,4.354,6.918,1.044,13.192-1.483,16.707-.67,2.663.617,4.292,5.477,4.864,9.935s3.456,5.824,2.885,10.868C101.131,52.457,95.417,59.309,94,64a45.1,45.1,0,0,0,10.819-7.049c5.919-5.358,11.809-15.82,13.069-26s-3.4-18.719-10.663-22.971",
    transform: "translate(-72.401 -5.444)",
    fill: "#f2a983"
  }))))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1581",
    "data-name": "\\u30D1\\u30B9 1581",
    d: "M107.249,3.711C96.021-3.134,83.58.684,77.3,5.575c-2.2,1.712-4.643,4.276-7.122,9.482-2.041,4.286-1.559,12.739,8.21,12.891,5.284.081,12.178-1.367,17.4-2.719,5.931,3.342,4.044,9.551,4.938,11.534s1.89,4.533,3.22,5.187c.814.4,2.22-.98,2.575-1.445.863-1.127,6.869-9.025,7.857.207a42.308,42.308,0,0,0,2.915-10.769,26.088,26.088,0,0,0,.178-4.426c1.591-3.756.6-15.211-10.219-21.807",
    transform: "translate(-12.91 0)",
    fill: "#000021"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1582",
    "data-name": "\\u30D1\\u30B9 1582",
    d: "M107.809,42.617c.9,1.982,1.89,4.533,3.22,5.187.814.4,2.22-.98,2.575-1.444.862-1.127,6.869-9.026,7.856.207a42.325,42.325,0,0,0,2.915-10.77,26,26,0,0,0,.177-4.426c-5.9,3.516-13.336,5.109-17.367,5.755.442,2.307.159,4.466.623,5.492",
    transform: "translate(-19.996 -5.852)",
    fill: "#000021"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1583",
    "data-name": "\\u30D1\\u30B9 1583",
    d: "M78.941,77.7C79,69.17,77.159,64.973,77.159,64.973c-.118-.364-1.67.149-2.908-.179l0,0a38.936,38.936,0,0,1,1.386,6.279c.083,1.341.184,5.082,3.3,6.626",
    transform: "translate(-13.852 -12.088)",
    fill: "#f4c1a3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1584",
    "data-name": "\\u30D1\\u30B9 1584",
    d: "M115.188,57.24c.871.484,2.861,1.132,6.39-3.153s3.228-8.1,1.274-9.255a3.162,3.162,0,0,0-4.593,1.261c-.88,1.533-3.072,11.147-3.072,11.147",
    transform: "translate(-21.489 -8.265)",
    fill: "#f6cbb0"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_143",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 143",
    transform: "translate(68.535 161.594)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_142",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 142"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_141",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 141",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1586",
    "data-name": "\\u30D1\\u30B9 1586",
    d: "M115.54,219.054c8.127,2.594,12.285,27.324,11.942,47.064h0a55.643,55.643,0,0,0,11.7-6.183s-16.137-42.581-15.519-61.28l-35.443,7.97-3.251.7c0,.033,0,.066,0,.1-.111,2.331-.233,4.632-.386,6.852,0,.009,0,.02,0,.028-.012.174-.024.348-.036.523-.059.826-.121,1.645-.191,2.444-.041.464-.068.912-.1,1.368,7.67-.715,24.089-1.877,31.287.42",
    transform: "translate(-84.253 -198.654)",
    fill: "#162a3d"
  }))))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1587",
    "data-name": "\\u30D1\\u30B9 1587",
    d: "M101.5,227.992l1.7,11.082,21.436-5.541-19.637,3.516Z",
    transform: "translate(-18.935 -42.533)",
    fill: "#162a3d"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1588",
    "data-name": "\\u30D1\\u30B9 1588",
    d: "M38.927,114.286a15.719,15.719,0,0,0,.079-5.013c-.464-1.886-4.175-4.276-6.2-6.778s-3.983-5.838-5.113-7.416-3.646-.163-3.765,2.695.648,4.627,3.651,7.628,5.334,4.838,1.778,7.3,9.569,1.587,9.569,1.587",
    transform: "translate(-4.462 -17.615)",
    fill: "#f4c1a3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1589",
    "data-name": "\\u30D1\\u30B9 1589",
    d: "M22.943,103.646,8.556,96.336a2.157,2.157,0,0,1-1.122-1.428L.06,63.627a2.157,2.157,0,0,1,3.076-2.418l14.387,7.31a2.154,2.154,0,0,1,1.123,1.428l7.372,31.28a2.156,2.156,0,0,1-3.076,2.418",
    transform: "translate(0 -11.374)",
    fill: "#8180c9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1590",
    "data-name": "\\u30D1\\u30B9 1590",
    d: "M38.329,123.261c-2.463-1.609-1.273-4.059-1.828-7.825s-.717-7.362-2.038-8.993-7.336,1.86-8.505,2.069a9.64,9.64,0,0,1-5.155-1.127c-1.546-.87-5.027-4.113-5.67-7.016s-.451-10.247-.451-10.247c-2.663-4.414-7.533,9.507-7.614,12.42s1.7,10.807,2.275,12.334,10.078,7.01,12.288,9.571,5.963,8.654,11.623,12.59l11.687-9.926c-3.207-1.833-5.727-3.272-6.612-3.852",
    transform: "translate(-1.318 -16.653)",
    fill: "#f6cbb0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1591",
    "data-name": "\\u30D1\\u30B9 1591",
    d: "M38.03,133.4c-2.666-2.758-8.628-8.884-11.127-11.11-3.265-2.9-9.268-6.024-12.447-8.657C11.72,111.363,10.072,98.687,11.3,91.5c-2.152,3.177-4.184,9.591-4.235,11.464-.081,2.914,1.7,10.807,2.275,12.333s10.078,7.011,12.288,9.571,5.964,8.654,11.623,12.591Z",
    transform: "translate(-1.318 -17.069)",
    fill: "#f4c1a3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1592",
    "data-name": "\\u30D1\\u30B9 1592",
    d: "M44.621,119.53,27.548,134.619s40.119,34.936,51.2,35.591S112.8,153.967,117.644,149s23.591-15.043,23.591-38.405c0-6.608-12.464-13.565-27.2.981s-34.351,34.754-34.351,34.754Z",
    transform: "translate(-5.139 -19.215)",
    fill: "#4a4845"
  })))))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_23",
    "data-name": "\\u7DDA 23",
    x2: 72,
    y2: 12,
    transform: "translate(345.5 850.5)",
    fill: "none",
    stroke: "#ccc",
    strokeWidth: 2,
    strokeDasharray: "2 3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfie);
export default __webpack_public_path__ + "static/media/selfie.09e9597b1d0eb3406eb32e866e5d454b.svg";
export { ForwardRef as ReactComponent };